import { z } from 'zod';
import { email } from './common';

export const shareScript = z.object({
  email,
  script: z.string(),
});

const booleanString = z.enum(['true', 'false']);

const hexColor = z
  .string()
  .length(7)
  .regex(/#([a-f0-9A-F]){6}/);

const optionalNumber = z.string().regex(/^\d+$/, 'INVALID_NUMBER');

const position = z.enum(['left', 'right', 'center', 'top', 'bottom']);

const size = z.enum(['small', 'medium', 'big']);

const unit = z.union([z.literal('0'), z.string().regex(/^\d+(px|%)$/)]);

const consistentHelpItem = z.object({
  title: z.string().optional(),
  description: z.string().optional(),
});

export const customInstallationScript = z.object({
  footerHtml: z.string().optional(),
  consistentHelpData: z.array(consistentHelpItem).max(14).optional(),
  hideTrigger: booleanString,
  language: z.string().length(2),
  leadColor: hexColor,
  hideMobile: booleanString,
  mobileTriggerOffsetX: optionalNumber,
  mobileTriggerOffsetY: optionalNumber,
  mobileTriggerPositionX: position,
  mobileTriggerPositionY: position,
  mobileTriggerRadius: unit,
  mobileTriggerSize: size,
  position,
  statementLink: z.string().url('INVALID_URL').or(z.string().length(0)),
  triggerColor: hexColor,
  triggerIcon: z.string(),
  triggerOffsetX: optionalNumber,
  triggerOffsetY: optionalNumber,
  triggerPositionX: position,
  triggerPositionY: position,
  triggerRadius: unit,
  triggerSize: size,
});

export type CustomInstallationConfig = z.infer<typeof customInstallationScript>;
